import React, { useEffect, useState } from "react";
import { getDatabase, ref, onValue } from "firebase/database";
import { useNavigate } from "react-router-dom";

function ClientsListPage({ uid }) {
  const db = getDatabase();
  const navigate = useNavigate();

  const [clients, setClients] = useState([]);
  const [search, setSearch] = useState("");

  // 🔄 تحميل العملاء
  useEffect(() => {
    const clientsRef = ref(db, `distributors/${uid}/clientsAdd`);

    return onValue(clientsRef, (snapshot) => {
      if (!snapshot.exists()) {
        setClients([]);
        return;
      }

      const data = snapshot.val();
      const list = Object.keys(data).map((id) => ({
        id,
        ...data[id],
      }));

      // 🔢 احسب ديون كل زبون إذا كانت موجودة
      const listWithDebt = list.map((client) => ({
        ...client,
        totalDebt: client.totalDebt || 0, // افتراضياً 0 إذا لم توجد
      }));

      setClients(listWithDebt);
    });
  }, [uid]);

  // 🔍 فلترة البحث
  const filteredClients = clients.filter(
    (c) =>
      (c.fullName &&
        c.fullName.toLowerCase().includes(search.toLowerCase())) ||
      (c.phone && c.phone.includes(search))
  );

  // 🟢 احسب مجموع الديون
  const totalDebt = filteredClients.reduce(
    (sum, c) => sum + (c.totalDebt || 0),
    0
  );

  return (
    <div style={{ maxWidth: 700, margin: "auto" }}>
      <h2>👥 Liste des clients</h2>

      <div style={{ marginBottom: 16, fontWeight: 600 }}>
        Total Solde Impayé: {totalDebt} DA
      </div>

      {/* 🔍 Search */}
      <input
        placeholder="🔍 Rechercher par nom ou téléphone"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        style={{
          width: "100%",
          padding: 10,
          marginBottom: 16,
          borderRadius: 8,
          border: "1px solid #ccc",
        }}
      />

      {/* ➕ Add Client */}
      <button
        onClick={() => navigate("/add-client")}
        style={{
          marginBottom: 20,
          padding: "10px 16px",
          borderRadius: 8,
          background: "#16a34a",
          color: "#fff",
          border: "none",
          cursor: "pointer",
        }}
      >
        ➕ Ajouter un client
      </button>

      {/* 📋 List */}
      {filteredClients.map((c) => (
        <div
          key={c.id}
          style={{
            padding: 14,
            marginBottom: 10,
            borderRadius: 10,
            background: "#f9fafb",
            display: "flex",
            justifyContent: "space-between",
            cursor: "pointer",
          }}
          onClick={() =>
            navigate(`/client-orders/${c.id}`, {
              state: { clientName: c.fullName, clientId: c.id },
            })
          }
        >
          <div>
            <div style={{ fontWeight: 600 }}>{c.fullName}</div>
            <div style={{ fontSize: 14, color: "#6b7280" }}>
              📞 {c.phone}
            </div>
            <div style={{ fontSize: 13 }}>
              📍 {c.wilaya} - {c.commune}
            </div>
            <div
              style={{
                fontSize: 13,
                color: c.totalDebt > 0 ? "red" : "green",
                fontWeight: 500,
              }}
            >
              Solde Impayé: {c.totalDebt} DA
            </div>
          </div>

          {/* ✏️ تعديل */}
          <button
            onClick={(e) => {
              e.stopPropagation(); // لمنع الانتقال لصفحة الطلبيات
              navigate(`/edit-client/${c.id}`);
            }}
            style={{
              background: "#2563eb",
              color: "#fff",
              border: "none",
              borderRadius: 6,
              padding: "6px 10px",
              cursor: "pointer",
              height: 36,
            }}
          >
            Modifier le client
          </button>
        </div>
      ))}

      {filteredClients.length === 0 && (
        <div style={{ color: "#6b7280" }}>لا يوجد عملاء</div>
      )}
    </div>
  );
}

export default ClientsListPage;